import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import { MenuVisibleContext } from '../../context';

const Body = (props) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const { children, hideFooter } = props;

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  useEffect(() => {
    const gatsbyDiv = document.getElementById('___gatsby');
    // Handle disabling overflow scroll
    menuVisible && gatsbyDiv
      ? gatsbyDiv.classList.add('overflow-hidden')
      : gatsbyDiv.classList.remove('overflow-hidden');
  }, [menuVisible]);

  return (
    <div className="cppc__scroll_direction_wrapper">
      <div className="cppc__content_wrapper">
        <Header toggleMenu={toggleMenu} menuVisible={menuVisible} />
        <MenuVisibleContext.Provider value={menuVisible}>
          {children}
        </MenuVisibleContext.Provider>
      </div>
      {!hideFooter && (
        <div className="cppc__footer_wrapper">
          <Footer />
        </div>
      )}
    </div>
  );
};

export default Body;
